module.exports = __webpack_public_path__ + "img/logo-min.04f05f87.png";